"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const en_GB_1 = __importDefault(require("date-fns/locale/en-GB")); //
const dateEnGB = {
    name: 'en-GB',
    locale: en_GB_1.default
};
exports.default = dateEnGB;
